module.exports = __webpack_public_path__ + "img/9788932019352.204762ac.jpg";